import Global from '@/scripts/Global';
import VueSignals from '@/scripts/VueSignals';
export default {
    name: 'UserDetails',
    data: function() {
        return {

        }
    },
    mounted() {

    },
    props: {
        user_doc: '',

    },
    methods: {
        openMediaModal() {
            Global.globalValue(VueSignals.SHOW_SMALL_MODAL, true);
            Global.globalValue(VueSignals.SHOW_SMALL_MODAL_TYPE, VueSignals.MEDIA_MODAL);
            Global.globalValue(VueSignals.SMALL_OVERLAY_DATA, {'url': this.user_doc.image_doc});
        }
    }
}
